import { useMemo } from "react";
import { ThemeProvider } from "@mui/material";
import { useColorMode } from "../../contexts/ColorModeContext";
import { buildHomeV2Theme } from "./theme";

/**
 * Provider do layout Home V2.
 * Consome o ColorMode global e aplica o tema MUI da home.
 */
const HomeV2Provider = ({ children }) => {
  const { mode } = useColorMode();
  const theme = useMemo(() => buildHomeV2Theme(mode), [mode]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default HomeV2Provider;
